module.exports = __webpack_public_path__ + "media/images/make_it_switch_banner_mobile-c9559444c6ed8f22439ca00145c172d7.jpg";